import { render } from "./Aftershou_A.vue?vue&type=template&id=463262b0&scoped=true"
import script from "./Aftershou_A.vue?vue&type=script&lang=js"
export * from "./Aftershou_A.vue?vue&type=script&lang=js"

import "./Aftershou_A.vue?vue&type=style&index=0&id=463262b0&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-463262b0"]])

export default __exports__